// The GSC kiosk simulator's checks and its reading of the status call (GscKioskModel).
import { type KioskExchange } from './api';

export const KYC_MAX_TOTAL = 1000;

export const isCardNumber = (value: string) => /^\d{13,19}$/.test(value);

/** The kiosk's own checks before any call: card number, positive amount, no negative fee, the $1,000 KYC limit. */
export function kioskProblem(cardNumber: string, amount: number, fee: number): string | null {
  if (!isCardNumber(cardNumber)) return 'Card number must be 13-19 digits, numbers only.';
  if (!(amount > 0)) return 'Enter a positive amount to load.';
  if (fee < 0) return "Fee can't be negative.";
  const total = amount + fee;
  if (total > KYC_MAX_TOTAL)
    return `Total (load ${amount.toFixed(2)} + fee ${fee.toFixed(2)} = ${total.toFixed(2)} USD) exceeds the $1,000 per-transaction KYC limit. The kiosk would reject this before ever calling the API.`;
  return null;
}

/** ParseStatus: found / status / balance from a successful status call's JSON. */
export function parseKioskStatus(exchange: KioskExchange): {
  found: boolean;
  status: string | null;
  balance: number | null;
} {
  const none = { found: false, status: null, balance: null };
  if (!exchange.success) return none;
  try {
    // the API's envelope ({ data }); money as "25.00"
    const parsed = JSON.parse(exchange.responseJson) as { data?: Record<string, unknown> } & Record<string, unknown>;
    const root = parsed.data ?? parsed;
    const balance = typeof root.balance === 'string' || typeof root.balance === 'number' ? Number(root.balance) : null;
    return {
      found: root.found === true,
      status: typeof root.status === 'string' ? root.status : null,
      balance: balance !== null && Number.isFinite(balance) ? balance : null,
    };
  } catch {
    return none;
  }
}
